module.exports = __webpack_public_path__ + "img/household.fd6dc015.png";